import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const Screening = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.SCREENING} />
}

export default Screening;